import styled from 'styled-components';

import { cardBoxShadow, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

import { linkStyles } from '../Header.styled';

export const Menu = styled.div`
    position: relative;
    padding: 0 1rem;

    ${respondDown(Breakpoints.lg)`
        padding: 0 1.2rem;
    `}
`;

export const MenuHead = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    padding: 0.2rem;

    ${respondDown(Breakpoints.md)`
        display: none;
    `}
`;

export const MenuHeadTitle = styled.div`
    ${linkStyles};
    font-size: 1.6rem;
    color: ${COLORS.textPrimary};
    display: flex;
    align-items: center;
    gap: 0.8rem;
    white-space: nowrap;
`;

export const MenuLinks = styled.div<{ $isOpen: boolean }>`
    ${cardBoxShadow};
    display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    background: ${COLORS.white};
    padding: 2.4rem;
    left: 0;
    border-radius: 0.5rem;

    a {
        width: fit-content;

        &:not(:last-child) {
            margin: 0 0 1.2rem 0;
        }
    }

    ${respondDown(Breakpoints.md)`
        display: flex;
        position: relative;
        box-shadow: unset;
        align-items: center;

        a:not(:last-child) {
            margin-bottom: 2.4rem;
        }
    `}
`;

export const CountSlot = styled.span`
    display: inline-flex;
    width: 2rem;
    height: 2rem;
    flex-shrink: 0;
`;
